import { defa } from 'defa-object';
import Service  from 'scripts/poppet/service';

/**
 * defa.services.NavHandler
 * A handler for all Nav requests
 * @version 1.2.2
 */


const routes = {
	
	'app:root'   : '/',
	'app:install': '/application-install/',
	
	'roleapplication:list'   : '/roleapplications/',
	'roleapplication:review' : '/roleapplications/%s/',
	
	'customer:list'    : '/billing/accounts/%s/',
	'customer:create'  : '/billing/create/%s/',
	'customer:update'  : '/billing/%s/',
	'customer:invoices': '/billing/%s/invoices/',
	
	'invoice:update': '/invoices/%s/',
	
	'legacy:migrate'   : '/legacy/migrate/',
	'legacy:migrate:id': '/legacy/migrate/%s/',
	'log'              : '/logs/%s/%s/%s/',
	'map'              : '/map/',
	
	'phone:list'  : '/accounts/%s/phone-numbers/',
	'phone:create': '/accounts/%s/phone-numbers/create/',
	'phone:update': '/accounts/%s/phone-numbers/%s/',
	'phone:delete': '/accounts/%s/phone-numbers/%s/delete/',
	
	'show:terms' : '/terms-and-conditions/',

	'subscription:panel'    : '/subscriptions/%s/',
	'subscription:transfer' : '/subscriptions/%s/transfer/',
	'subscription:terminate': '/subscriptions/%s/terminate/',
	'subscription:replace'  : '/subscriptions/%s/replace/',
	
	'user:panel'   : '/accounts/%s/',
	'user:language': '/accounts/%s/language/',
	'user:password': '/accounts/%s/password/',
	'user:email'   : '/accounts/%s/email/',
	
	'user:me'         : '/accounts/me/',
	'user:login'      : '/accounts/login/',
	'user:create'     : '/accounts/new/',
	'user:logincreate': '/accounts/login/create/',
	'user:forgot'     : '/accounts/forgot-password/',
	
	'user:thankyou': '/accounts/thank-you/',
	
	'unit:list'              : '/devices/',
	'unit:search:serial'     : '/devices/search/',
	'unit:search:native'     : '/devices/new/',
	'unit:help'              : '/devices/help/',
	'unit:bluetooth'         : '/devices/bluetooth/',
	'unit:installed:select'  : '/devices/installed/',
	'unit:installed:selected': '/devices/installed/%s/%s/',
	
	'unit:panel'            : '/devices/%s/',
	'unit:install'          : '/devices/%s/install/',
	'unit:delete'           : '/devices/%s/delete/',
	'unit:details'          : '/devices/%s/details/',
	'unit:reset'            : '/devices/%s/reset/',
	'unit:test'             : '/devices/%s/test/',
	'unit:testresults'      : '/devices/%s/testresults/',
	'unit:alias'            : '/devices/%s/alias/',
	'unit:notes'            : '/devices/%s/notes',
	'unit:location'         : '/devices/%s/location/',
	'unit:complaint'        : '/devices/%s/complaint/',
	'unit:vehicle'          : '/devices/%s/vehicle/',
	'unit:recipients'       : '/devices/%s/recipients',
	'unit:recipients:new'   : '/devices/%s/recipients/new',
	'unit:recipient:edit'   : '/devices/%s/recipients/%s/edit',
	'unit:recipient:delete' : '/devices/%s/recipients/%s/delete',
	
	'unit:control:overview'       : '/devices/%s/control/',
	'unit:control:zones'          : '/devices/%s/control/zones/',
	'unit:control:zone'           : '/devices/%s/control/zones/%s',
	'unit:control:alarm'          : '/devices/%s/control/alarm/',
	'unit:control:gpai'           : '/devices/%s/control/gpai/',
	'unit:control:alarm:settings' : '/devices/%s/control/alarmSettings/',
	'unit:control:accessories'    : '/devices/%s/control/accessories',
	'unit:control:notifications'  : '/devices/%s/control/notifications/',
	'unit:control:notifications:all': '/devices/%s/control/notifications/all',
	'unit:control:notifications:recipients': '/devices/%s/control/notifications/recipients',
	'unit:control:calendar'     : '/devices/%s/control/calendar/',
	'unit:control:weather'      : '/devices/%s/control/weather/',
	'unit:control:finder'       : '/devices/%s/control/finder/',
	'unit:control:map'          : '/devices/%s/control/map/',
	'unit:control:details'      : '/devices/%s/control/details/',
	'unit:control:technical'    : '/devices/%s/control/technical/',
	'unit:control:settings'     : '/devices/%s/control/settings/',
	'unit:control:pickupTimes'  : '/devices/%s/control/pickupTimes/',
	'unit:control:warmupStates' : '/devices/%s/control/warmupStates/',
	'unit:control:genericStates': '/devices/%s/control/genericStates/',
	'unit:control:security'  	: '/devices/%s/control/security/',
	'unit:control:dayAndNight'  : '/devices/%s/control/dayAndNight/',
	
	'external:downloads': 'http://www.defa.com/?p=%s',
	'external:manuals'  : 'http://www.hyttami.no/kundeservice/brukerveiledninger',
	'external:acp'      : '%s/acp/index',
	'external:tsp'      : '%s/tsp/index',
	'external:dtp'      : '%s/danTrack/associateUnitWithCustomer',
	'external:unit'     : '%s/hm/unit/%s',
	
	'redirect:external' : '%s',
	'redirect:internal' : '%s',
};

const NavHandler = Service.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	channelName: 'nav',
	
	radioEvents: {
		'all' : 'onRoute',
		'back': 'historyBack',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Navigates the history one back.
	 * @void
	 */
	historyBack: function () {
		console.log( 'N::historyBack' );
		if ( defa.vars.newNav ) {
			window.history.go( -1 );
		}
	},
	
	/**
	 * Catches all incoming events to the nav channel.
	 * @param {string} event    Name of the event triggered.
	 * @param {array}  params   Array of important parameters.
	 * @param {object} options  Optional object with history navigate options.
	 */
	onRoute: function( event, params, options ) {
		
		// options defaults to trigger true.
		options = options || {trigger: true,};
		
		// get the route from the routes array
		let route = (routes[event])
			? routes[event]
			: '/';
		
		// use params to format the chosen route
		_.each(params, function (param) {
			route = route.replace('%s', param);
		});
		
		if ('redirect:' === event.substr(0,9)) {
			route = decodeURIComponent(route);
		}
		// direct nav, reload nav or new tab.
		if ('external:' === event.substr(0, 9)) {
			window.open(route);
		} else if ('redirect:external' === event.substr(0 ,17)) {
			if (this.validateRedirectUrl(route)) {
				window.location.replace(route);
			} else {
				let fallBackRoute = (routes[options.fallbackEvent]) ? routes[options.fallbackEvent] : '/';
				Bb.history.navigate( fallBackRoute, {trigger: true});
			}
		} else if ( options.reload ) {
			window.location.href = route;
		} else if ( options.refresh ) {
			Bb.history.navigate( '/r' );
			Bb.history.navigate( route, options );
		} else {
			Bb.history.navigate( route, options );
		}
	},
	
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	validateRedirectUrl: function ( url ) {
		let decodedUrl = decodeURIComponent( url );
		if ( decodedUrl ) {
			let allowedUrls = [ 'https://www.defa.com' ];
			for ( let i = 0; i < allowedUrls.length; i++ ) {
				let allowedUrl = allowedUrls[i];
				if ( decodedUrl.substring( 0, allowedUrl.length ) === allowedUrl ) {
					return true;
				}
			}
		}
		return false;
	},
} );

export default NavHandler;
